<template>
  <section id="hero" class="hero-container">
    <div class="hero-content">
      <div class="badge code-font">Backend Developer</div>
      <h1 class="headline">
        Building <br />
        <span class="gradient-text">Robust Systems</span> <br />
        For Users.
      </h1>
      <p class="sub-text">
        문제 해결의 본질을 탐구하는 개발자 <strong>김태영</strong>입니다.<br />
        사용자 경험을 지탱하는 견고한 백엔드 시스템을 설계합니다.
      </p>
    </div>
    <div class="scroll-downs">
      <div class="mousey">
        <div class="scroller"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "HeroSection" };
</script>

<style scoped>
.hero-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  padding-top: 0; /* Remove default section padding impact */
}

.badge {
  background: var(--accent-glow);
  color: var(--accent-color);
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 24px;
  display: inline-block;
}

.headline {
  font-size: 5rem;
  line-height: 1.1;
  margin-bottom: 30px;
  color: var(--text-primary);
}

.gradient-text {
  background: linear-gradient(90deg, var(--accent-color), #c084fc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sub-text {
  font-size: 1.25rem;
  color: var(--text-secondary);
  max-width: 600px;
  font-weight: 400;
}

.scroll-downs {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}
.mousey {
  width: 3px;
  padding: 10px 15px;
  height: 35px;
  border: 2px solid var(--text-tertiary);
  border-radius: 25px;
  opacity: 0.75;
  box-sizing: content-box;
}
.scroller {
  width: 3px;
  height: 10px;
  border-radius: 25%;
  background-color: var(--text-primary);
  animation-name: scroll;
  animation-duration: 2.2s;
  animation-timing-function: cubic-bezier(0.15, 0.41, 0.69, 0.94);
  animation-iteration-count: infinite;
}
@keyframes scroll {
  0% {
    opacity: 0;
  }
  10% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(15px);
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .headline {
    font-size: 3rem;
  }
  .sub-text {
    font-size: 1rem;
  }
  .hero-container {
    align-items: center;
    text-align: center;
  }
}
</style>
